/*
 * Special placeholder code ('******') used for requesting verification code resends.
 *
 * When initiating sign-in, this placeholder triggers an immediate "resend" to
 * specify the delivery method (email/SMS) since Cognito doesn't include this info
 * in the initial auth flow.
 */
export const SEND_ANSWER_PLACEHOLDER = '******';
